module.exports = __webpack_public_path__ + "img/ageTech_Platform_logo.8ebb1f6b.png";